import { render, staticRenderFns } from "./SelectedOptionsMenu.vue?vue&type=template&id=a4384c94"
import script from "./SelectedOptionsMenu.vue?vue&type=script&lang=js"
export * from "./SelectedOptionsMenu.vue?vue&type=script&lang=js"
import style0 from "./SelectedOptionsMenu.vue?vue&type=style&index=0&id=a4384c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports